import { LoadableLazy } from '@confluence/loadable';

export const SpaceRolesOnboardingModal = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-SpaceRolesOnboardingModal" */ '../src/onboarding/SpaceRolesOnboardingModal'
			)
		).SpaceRolesOnboardingModal,
});

export const InProductOnboardingFlag = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-InProductOnboardingFlag" */ '../src/onboarding/InProductOnboardingFlag'
			)
		).InProductOnboardingFlag,
});
